export default __webpack_public_path__ + "static/media/working3.921595cf.png";